import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import clsx from 'clsx';
import { Button } from '../ui/button';
interface SiteHeaderProps {
  readonly brand?: string;
  readonly variant?: 'transparent' | 'solid';
}
export function SiteHeader(t0) {
  const $ = _c(13);
  const {
    brand: t1,
    variant: t2
  } = t0;
  const brand = t1 === undefined ? "Lapids" : t1;
  const variant = t2 === undefined ? "transparent" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      id: "cases",
      label: "Projetos"
    }, {
      id: "finishes",
      label: "Acabamentos"
    }, {
      id: "process",
      label: "Processo"
    }, {
      id: "faq",
      label: "FAQ"
    }];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const sections = t3;
  let t4;
  if ($[1] !== variant) {
    t4 = clsx("fixed inset-x-0 top-0 z-50 px-fluid-x py-2", "bg-[color:var(--header-bg)] supports-[backdrop-filter]:bg-[color:var(--header-bg-backdrop)]", "text-[color:var(--header-fg)] shadow-[var(--header-shadow)]", "transition-[color,background-color,box-shadow] duration-500 ease-[cubic-bezier(0.22,0.61,0.36,1)]", "[backdrop-filter:blur(4px)_saturate(120%)] md:[backdrop-filter:blur(9px)_saturate(135%)]", variant === "transparent" && ["supports-[animation-timeline:scroll()]:animate-[site-header-scroll_1ms_ease-in-out_both]", "supports-[animation-timeline:scroll()]:[animation-timeline:scroll(root_block)]", "supports-[animation-timeline:scroll()]:[animation-range:0px_160px]", "supports-[animation-timeline:scroll()]:[animation-timing-function:cubic-bezier(0.22,0.61,0.36,1)]", "supports-[animation-timeline:scroll()]:motion-reduce:animate-none"]);
    $[1] = variant;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== brand) {
    t5 = <Link className="text-brand font-medium uppercase tracking-up-lg notranslate" href="/" prefetch={true} aria-label="Go to start" translate="no">{brand}</Link>;
    $[3] = brand;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <nav className="hidden md:flex items-center gap-nav-gap" aria-label="Primary">{sections.map(_temp)}</nav>;
    t7 = <Button variant="minor" href="/get-a-quote" aria-label="Get a quote" prefetch={false}>Fazer Orçamento</Button>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5) {
    t8 = <div className="max-w-container-max mx-auto flex min-h-size-header items-center justify-between gap-3">{t5}{t6}{t7}</div>;
    $[7] = t5;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t8 || $[11] !== variant) {
    t9 = <header id="site-header" data-variant={variant} className={t4}>{t8}</header>;
    $[9] = t4;
    $[10] = t8;
    $[11] = variant;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}
function _temp(s) {
  return <a key={s.id} href={`#${s.id}`} className={clsx("relative uppercase tracking-up transition-colors duration-300 ease-[cubic-bezier(0.22,0.61,0.36,1)]", "text-[color:var(--header-link-muted)] hover:text-[color:var(--header-link-strong)]", "after:content-[''] after:absolute after:bottom-[-6px] after:left-0", "after:h-px after:w-full", "after:origin-left after:scale-x-0", "after:transition-transform after:duration-300 after:ease-[cubic-bezier(0.22,0.61,0.36,1)]", "after:bg-[color:var(--header-link-strong)]", "hover:after:scale-x-100")}>{s.label}</a>;
}